<template>
  <hm-content title="">
    <div class="table-panel flex flex-end">
      <div>

        <el-radio-group v-model="typeCode" size="small" style="margin-right: 10px;" @change="handleTypeChange">
          <el-radio-button label="">全部</el-radio-button>
          <el-radio-button label="orderScoreConfig">商品订单</el-radio-button>
          <el-radio-button label="serviceReservationScoreConfig">服务订单</el-radio-button>
          <el-radio-button label="posOrderScoreConfig">线下订单</el-radio-button>
          <el-radio-button label="serviceItemScoreConfig">服务项目</el-radio-button>
        </el-radio-group>

        <template v-if="typeCode === 'serviceItemScoreConfig'">
          <el-select
            v-model="searchCondition.scoreLevel"
            clearable
            size="small"
            placeholder="评分筛选"
            style="width:130px;margin-right:10px;"
          >
            <el-option label="好评（≥4分）" value="good"></el-option>
            <el-option label="中评（3分）" value="neutral"></el-option>
            <el-option label="差评（≤2分）" value="bad"></el-option>
          </el-select>
          <el-select
            v-model="searchCondition.pointState"
            clearable
            size="small"
            placeholder="积分筛选"
            style="width:120px;margin-right:10px;"
          >
            <el-option label="已发积分" value="has"></el-option>
            <el-option label="未发积分" value="none"></el-option>
          </el-select>
          <el-select
            v-model="searchCondition.evalType"
            clearable
            size="small"
            placeholder="评价方式"
            style="width:120px;margin-right:10px;"
          >
            <el-option label="问卷评价" value="form"></el-option>
            <el-option label="传统评价" value="legacy"></el-option>
          </el-select>
        </template>

        <el-input
          clearable
          style="width:300px"
          v-model.trim="searchCondition.keyWords"
          placeholder="请输入单号/会员手机号/服务项目/门店"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-date-picker
          v-model="searchCondition.applyDate"
          :default-time="['00:00:00', '23:59:59']"
          type="datetimerange"
          align="right"
          start-placeholder="請选择晒单时间段"
          end-placeholder="請选择晒单时间段"
          value-format="yyyy-MM-dd HH:mm:ss"
          size="small"
          class="mr10"
        ></el-date-picker>
        <el-button type="primary" size="small" @click="search">查询</el-button>
        <el-button
          type="success"
          size="small"
          @click="output('queryAllList', '订单评价结果')"
          :loading="isOutputing"
          >导出</el-button
        >
      </div>
    </div>
    <div>
      <el-table
        stripe
        border
        ref="table"
        :data="list"
        style="width: 100%"
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          header-align="center"
          align="center"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="receiptSn"
          label="单号"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="memberMobile"
          label="会员电话号码"
        >
        </el-table-column>
        <el-table-column
          v-if="typeCode === 'serviceItemScoreConfig'"
          header-align="center"
          align="center"
          prop="companyName"
          label="服务门店"
        >
          <template slot-scope="scope">{{ scope.row.companyName || "-" }}</template>
        </el-table-column>
        <el-table-column
          v-if="typeCode === 'serviceItemScoreConfig'"
          header-align="center"
          align="center"
          prop="itemTypeName"
          label="二级类目"
        >
          <template slot-scope="scope">{{ scope.row.itemTypeName || "-" }}</template>
        </el-table-column>
        <el-table-column
          v-if="typeCode === 'serviceItemScoreConfig'"
          header-align="center"
          align="center"
          prop="overallScore"
          label="整体评分"
        >
          <template slot-scope="scope">
            {{ scope.row.overallScore != null ? scope.row.overallScore + "分" : "-" }}
          </template>
        </el-table-column>
        <el-table-column
          v-if="typeCode === 'serviceItemScoreConfig'"
          header-align="center"
          align="center"
          prop="pointAmount"
          label="积分"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.pointAmount > 0" class="success">
              +{{ formatPoint(scope.row.pointAmount) }}
            </span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="typeCode === 'serviceItemScoreConfig'"
          header-align="center"
          align="center"
          prop="formId"
          label="评价方式"
        >
          <template slot-scope="scope">{{ scope.row.formId ? "问卷" : "传统" }}</template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="createTime"
          label="评价时间"
        >
          <template slot-scope="scope">{{ scope.row.evalSubmitTime || scope.row.createTime }}</template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="referName"
          label="评分详情"
        >
          <template slot-scope="scope">
            <div class="blue" v-if="scope.row.serviceScore !== null">
              服务{{ scope.row.serviceScore }}星
            </div>
            <div class="blue" v-if="scope.row.envScore !== null">
              环境{{ scope.row.envScore }}星
            </div>
            <div class="blue" v-if="scope.row.expressScore !== null">
              配送{{ scope.row.expressScore }}星
            </div>
            <div class="blue" v-if="scope.row.guiderScore !== null">
              导购{{ scope.row.guiderScore }}星
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="realname"
          label="导购/技师"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.realname">
              {{ scope.row.realname }}<span v-if="scope.row.workNum">（{{ scope.row.workNum }}）</span>
            </span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" label="操作">
          <template slot-scope="scope">
            <el-button v-if="scope.row.showId" size="small" type="text" @click="toDetails(scope.row)"
              >查看详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      title="评价详情"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="900px"
    >
      <div class="info-list">
        <div class="evaluation-info" v-if="detailRow">
          <div class="row">
            <span class="label">单号：</span>
            <span class="value">{{ detailRow.receiptSn }}</span>
          </div>
          <div class="row">
            <span class="label">会员电话：</span>
            <span class="value">{{ detailRow.memberMobile }}</span>
          </div>
          <div class="row">
            <span class="label">评价时间：</span>
            <span class="value">{{ detailRow.evalSubmitTime || detailRow.createTime }}</span>
          </div>
          <div class="row" v-if="detailRow.companyName">
            <span class="label">服务门店：</span>
            <span class="value">{{ detailRow.companyName }}</span>
          </div>
          <div class="row" v-if="detailRow.itemTypeName || detailRow.itemName">
            <span class="label">二级类目：</span>
            <span class="value">
              {{ detailRow.itemTypeName || "-" }}
              <span v-if="detailRow.itemName"> / {{ detailRow.itemName }}</span>
            </span>
          </div>
          <div class="row" v-if="detailRow.realname">
            <span class="label">服务人员：</span>
            <span class="value">
              {{ detailRow.realname }}
              <span v-if="detailRow.workNum">（{{ detailRow.workNum }}）</span>
            </span>
          </div>
          <div class="row">
            <span class="label">评价方式：</span>
            <span class="value">{{ detailRow.formId ? "问卷评价" : "传统评价" }}</span>
          </div>
          <div class="row" v-if="detailRow.overallScore != null">
            <span class="label">整体评分：</span>
            <span class="value">{{ detailRow.overallScore }} 分</span>
          </div>
          <div class="row" v-if="detailRow.pointAmount > 0">
            <span class="label">评价积分：</span>
            <span class="value success">+{{ formatPoint(detailRow.pointAmount) }} 积分</span>
          </div>
          <div class="row" v-if="scoreText">
            <span class="label">评分详情：</span>
            <span class="value">{{ scoreText }}</span>
          </div>
        </div>
        <li class="mb20" v-if="detailRow.formId">
          <div class="title">问卷回答</div>
          <el-table
            v-if="questionnaireAnswers.length"
            :data="questionnaireAnswers"
            size="mini"
            border
            style="width:100%"
          >
            <el-table-column
              prop="questionCode"
              label="题号"
              width="80"
              align="center"
            ></el-table-column>
            <el-table-column prop="columnName" label="题目"></el-table-column>
            <el-table-column label="回答" width="140" align="center">
              <template slot-scope="scope">{{ formatAnswer(scope.row) }}</template>
            </el-table-column>
          </el-table>
          <div class="content" v-else>
            未查询到问卷原始数据（可能为历史数据或回调日志已过期）
          </div>
        </li>
        <li class="mb10" v-if="detail.showTitile">
          <div class="title">评价标题</div>
          <div class="content">{{ detail.showTitile }}</div>
        </li>
        <li class="mb10" v-if="detail.showContent">
          <div class="title">评价内容</div>
          <div class="content">{{ detail.showContent }}</div>
        </li>
        <li class="mb20" v-if="picList.length">
          <div class="title">评价图片</div>
          <div class="flex flex-wrap mb10">
            <el-image
              class="mr10"
              v-for="(v, i) in picList"
              :key="i"
              style="width:200px;height:200px"
              :src="v"
              :preview-src-list="picList"
            ></el-image>
          </div>
        </li>
        <li class="mb20" v-if="videoList.length">
          <div class="title">评价视频</div>
          <div class="flex flex-wrap">
            <video
              v-for="(v, i) in videoList"
              :key="i"
              :src="v.relValue"
              :poster="v.aviPoster"
              controls
              class="video"
              width="200px"
            >
              您的浏览器不支持播放。
            </video>
          </div>
        </li>
      </div>
    </el-dialog>
  </hm-content>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      isOutputing: false,
      typeCode: "",
      searchCondition: {
        keyWords: "",
        applyDate: [],
        scoreLevel: "",
        pointState: "",
        evalType: ""
      },
      currentPage: 1,
      pageSize: 10,
      list: [],
      total: 0,
      dialogVisible: false,
      detail: {},
      detailRow: {},
      picList: [],
      videoList: [],
      questionnaireAnswers: []
    };
  },
  computed: {
    scoreText() {
      const row = this.detailRow;
      if (!row) {
        return "";
      }
      let arr = [];
      if (row.serviceScore !== null && row.serviceScore !== undefined) {
        arr.push(`服务${row.serviceScore}星`);
      }
      if (row.envScore !== null && row.envScore !== undefined) {
        arr.push(`环境${row.envScore}星`);
      }
      if (row.expressScore !== null && row.expressScore !== undefined) {
        arr.push(`配送${row.expressScore}星`);
      }
      if (row.guiderScore !== null && row.guiderScore !== undefined) {
        arr.push(`导购${row.guiderScore}星`);
      }
      return arr.join(" ");
    }
  },
  watch: {},
  created() {},
  mounted() {
    //默认筛选近 7 天
    const fmt = d => {
      const pad = n => (n < 10 ? "0" + n : "" + n);
      return (
        d.getFullYear() +
        "-" +
        pad(d.getMonth() + 1) +
        "-" +
        pad(d.getDate())
      );
    };
    const end = new Date();
    const start = new Date();
    start.setDate(start.getDate() - 7);
    this.searchCondition.applyDate = [
      fmt(start) + " 00:00:00",
      fmt(end) + " 23:59:59"
    ];
    this.queryList();
  },
  methods: {
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    handleTypeChange() {
      this.searchCondition.scoreLevel = "";
      this.searchCondition.pointState = "";
      this.searchCondition.evalType = "";
      this.currentPage = 1;
      this.queryList();
    },
    formatPoint(value) {
      const num = Number(value);
      return num ? String(num) : "";
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    // 查看评价详情（标题/内容/图片/视频）
    async toDetails(row) {
      this.detailRow = row;
      this.detail = {};
      this.picList = [];
      this.videoList = [];
      this.questionnaireAnswers = [];
      const { result } = await this.$store.dispatch("findMemberShowComment", {
        showId: row.showId
      });
      this.detail = result || {};
      const rels = (result && result.relModelList) || [];
      rels.forEach(r => {
        if (r.relType === "pic") {
          this.picList.push(r.relValue);
        } else if (r.relType === "avi") {
          this.videoList.push({ relValue: r.relValue, aviPoster: r.aviPoster });
        }
      });
      if (row.formId && row.receiptSn) {
        let raw = row.answerJson;
        try {
          if (!raw) {
            const callbackRes = await this.$store.dispatch(
              "findEvaluationCallback",
              { receiptSn: row.receiptSn }
            );
            raw =
              callbackRes &&
              callbackRes.result &&
              callbackRes.result.answerJson;
          }
          if (raw) {
            const parsed = typeof raw === "string" ? JSON.parse(raw) : raw;
            const answers = Array.isArray(parsed)
              ? parsed
              : (parsed.answers || []);
            this.questionnaireAnswers = answers.filter(
              item => item && item.questionCode
            );
          }
        } catch (e) {
          this.questionnaireAnswers = [];
        }
      }
      this.dialogVisible = true;
    },
    formatAnswer(row) {
      if (!row) {
        return "-";
      }
      const value = row.value;
      if (value === null || value === undefined || value === "") {
        return "-";
      }
      if (Array.isArray(value)) {
        return value.join("、");
      }
      if (typeof value === "object") {
        return JSON.stringify(value);
      }
      return value;
    },
    async queryList(queryAll) {
      let params = {
        pageSize: queryAll ? 99999 : this.pageSize,
        pageNo: queryAll ? 1 : this.currentPage,
        code: this.typeCode
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.startTime = this.isArray(searchCondition.applyDate)
        ? searchCondition.applyDate[0]
        : "";
      searchCondition.endTime = this.isArray(searchCondition.applyDate)
        ? searchCondition.applyDate[1]
        : "";
      Object.assign(params, searchCondition);
      let name = queryAll
        ? "queryAllOrderScorePageList"
        : "queryOrderScorePageList";
      const { result } = await this.$store.dispatch(name, params);
      const { records, total } = result;
      if (!queryAll) {
        this.list = records;
        this.total = total;
      }

      return this.list;
    },
    // 导出excel
    output(funcName, title) {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        this.isOutputing = true;
        this.queryList(funcName)
          .then(res => {
            const list = res;

            const tHeader = this.$refs.table.columns
              .map(o => o.label !== "序号" && o.label !== "操作" && o.label)
              .filter(o => o);
            let filterVal = [];
            if (list.length > 0) {
              filterVal = this.$refs.table.$children
                .map(o => o._props.prop)
                .filter(o => o);
            }
            const data = this.formatJson(filterVal, list);
            exportJsonToExcel(
              tHeader,
              data,
              title + new Date().toLocaleString()
            );
            this.isOutputing = false;
          })
          .catch(() => {
            this.isOutputing = false;
          });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    }
  }
};
</script>
<style lang="scss" scoped>
.info-list {
  max-height: 70vh;
  overflow-y: auto;
  .title {
    margin-bottom: 10px;
    font-size: 14px;
    color: #333;
    font-weight: 500;
    &::before {
      display: inline-block;
      margin-right: 10px;
      content: "";
      width: 4px;
      height: 12px;
      background: #e50065;
      border-top-left-radius: 30px;
      border-bottom-right-radius: 30px;
    }
  }
  .evaluation-info {
    background: #f9fafb;
    border-radius: 10px;
    padding: 10px 16px;
    margin-bottom: 16px;
    .row {
      padding: 6px 0;
      .label {
        color: #909399;
        font-size: 14px;
      }
      .value {
        color: #333;
        font-size: 14px;
        font-weight: 500;
      }
    }
  }
  .content {
    color: #606266;
    font-size: 14px;
    line-height: 22px;
    word-break: break-all;
  }
}
</style>
